import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PollsState {
    optionVideoIndex: Record<string, number>;
    mutedAudio: boolean;
}

const initialState: PollsState = {
    optionVideoIndex: {},
    mutedAudio: false,
};

export const pollsSlice = createSlice({
    name: "polls",
    initialState,
    reducers: {
        setOptionVideoIndex: (state, action: PayloadAction<{ pollId: string; index: number }>) => {
            const { index, pollId } = action.payload;
            state.optionVideoIndex[pollId] = index;
        },
        setMutedAudio: (state, action: PayloadAction<boolean>) => {
            state.mutedAudio = action.payload;
        },
    },
});

export const { setOptionVideoIndex, setMutedAudio } = pollsSlice.actions;

export default pollsSlice.reducer;
